import { ApiClient } from "@/services/apiClient";
import { adjustSportsCardPrice } from "@/services/collectibles/collectiblesHelpers";
import type { Collectible, CollectibleId } from "@/services/collectibles/collectiblesTypes";
import { CategoryId } from "@/services/collection/categories";

/** @deprecated Still used in magazine widgets. Use Elastic Collectible instead. */
export const fetchCollectibleById = async (id: CollectibleId): Promise<Collectible> => {
  const url = "api-public/collectible/" + id;
  return ApiClient.getPublic<Collectible>(url).then(({ data }) => {
    // Sports cards: keep only the newest type="" price (rounded), discard the rest.
    if (data.categoryId === CategoryId.SportsCards) {
      // API may return price=0 entries; filter them out (workaround for ColectioOrg/api.colectio.com#403).
      const valid = data.prices.filter((p) => p.price.price > 0).sort((a, b) => b.date.localeCompare(a.date));
      const best = valid.find((p) => p.type === "") ?? valid[0];
      if (best !== undefined) {
        data.price = { ...best.price, price: adjustSportsCardPrice(best.price.price) };
      } else if (data.price !== null) {
        data.price = { ...data.price, price: adjustSportsCardPrice(data.price.price) };
      }
      data.prices = [];
    }
    return data;
  });
};
